import { INCLUDE_FIELD_MAP, ORDERING_MAP } from '@/api/adapters/field-mappings';

/**
 * Transforms teacher object to legacy API format
 * @param {Object} teacher - Teacher object
 * @returns {Object|null} Transformed teacher object or null
 */
export const transformTeacher = teacher => {
  if (!teacher?.id || teacher.name === 'All') return null;
  return { teacher: teacher.id };
};

/**
 * Transforms language ID to legacy API format
 * @param {string} languageId - Language ID
 * @returns {Object|null} Transformed language object or null
 */
export const transformLanguage = languageId => {
  if (!languageId) return null;
  return { language_id: languageId };
};

/**
 * Transforms feedback status to legacy API format
 * @param {boolean} hasFeedback - Feedback status
 * @returns {Object|null} Transformed feedback object or null
 */
export const transformFeedback = hasFeedback => {
  if (hasFeedback === undefined) return null;
  return { has_feedback: hasFeedback };
};

/**
 * Transforms class type to legacy API format
 * @param {string} classType - Class type
 * @returns {Object|null} Transformed class type object or null
 */
export const transformClassType = classType => {
  if (!classType) return null;
  return { class_type: classType === 'GROUP' ? 'group' : 'private' };
};

/**
 * Transforms include fields to legacy API format
 * @param {string[]} include - Include fields
 * @returns {Object|null} Transformed include object or null
 */
export const transformInclude = include => {
  if (!include || !include.length) return null;
  return {
    include: include.map(field => INCLUDE_FIELD_MAP[field] || field),
  };
};

/**
 * Transforms ordering to legacy API format
 * @param {string} ordering - Ordering field
 * @returns {Object|null} Transformed ordering object or null
 */
export const transformOrdering = ordering => {
  if (!ordering) return null;
  return {
    ordering: ORDERING_MAP[ordering] || ordering,
  };
};
